import ReactDOM from "react-dom";
import { UserContext } from "../Definitions/UserContext";
import { BusienssControlNames, GenericBusinessControl } from "./GenericBusinessControl";
import React from "react";
import LayoutNode from "../Definitions/LayoutNode";
import GenericDynamicComponent from "./GenericDynamicComponent";
import { ValidateToken } from "../Utilities/BusinessData";
import {hasAcceptedValue, getCookie,setCookie, GetTrackingCookieName } from "../Utilities/CookieUtils";
import { BindAllToggles } from "./BindAllToggles";
import { BindServiceLinks,BindClassLinks, BindMembershipLinks, BindPackageLinks } from "./BindServiceAndClassLinks";
import  GtagAccept  from "./GtagAccept";
import { wBComponentTypeNames } from "../Definitions/WBComponentTypeNames";
import { TrackingOnLoad } from "./TrackingOnLoad";
const dataBindKey = "data-link-key";
const componetAttKey = "component-attributes"

export default async function BindDataToComponents(businessId: string, accessToken: string, MultilocationData: any, bidHash: string, tokenExpiresAt?: number, isMysite?: boolean, onFinish?: Function, VGURL?: string, isDuplicateAllLocationPage?: boolean, sitebid?: string, nickname?: string, isShoppingCart?: boolean, websitename?: string, telephone?: string, isDormantPage?: boolean, staticencbid?: string, parentbid?: string, isDisplayHomeInVagaroPlus?: boolean) {
 
 

    //const expiresAt = (accessgenerationtime??0)  + 40 * 60000;

  //reassmble the user context from the input
    const context: UserContext = {
        businessId: businessId,
        accessToken: accessToken,
        styleId: "",
        layoutId: "",
        userId: 0,
        pages: [],
        userType: 1,
        encUserId: "",
        cdnURL: "",
        tokenExpiresAt: tokenExpiresAt,      
        imageMapping: [],
        MultilocationData : MultilocationData,
        isMysite : isMysite??false,
        bidHash :bidHash,
        vgurl:VGURL,
        isDuplicateAllLocationPage:isDuplicateAllLocationPage,
        sitebid:sitebid,
        nickname:nickname,
		isShoppingCart:isShoppingCart,
        websitename:websitename,
        telephone:telephone,
        staticencbid: staticencbid,
        parentbid: parentbid,
        isDormant: typeof isDormantPage === 'boolean' && isDormantPage === true ? true : false,
        isDisplayHomeInVagaroPlus: typeof isDisplayHomeInVagaroPlus === 'boolean' && isDisplayHomeInVagaroPlus === true ? true : false,
    }


    await ValidateToken(context);
    // Business Track Event on PageLoad
    if ((typeof isDormantPage === 'boolean' && isDormantPage === true) || (typeof isDisplayHomeInVagaroPlus === 'boolean' && isDisplayHomeInVagaroPlus === true)) {
        TrackingOnLoad(context);
    }

    try{

    //bind all business controls
    let dataBindElements = document.querySelectorAll(`[${dataBindKey}]`);

    dataBindElements.forEach((element) => {

        let layout = element.getAttribute("layout");
        let dataKey = element.getAttribute(dataBindKey);
        let bid = element.getAttribute("encbid");
        let filters = element.getAttribute("filters")??"";
        if(filters){
            filters = decodeURIComponent(filters);
        }


        let allowMulti =  element.getAttribute("multilocal") == "true" ? true:false;
        let isShowLogo =  element.getAttribute("isshowlogo") == "true" ? "true":"false";

        let displayform = element.getAttribute("displayform")??"true";
        let formbg =   element.getAttribute("formbg")??"";
        let formfc =  element.getAttribute("formfc")??"";


        //for certain components hide cta so it doesn't interfere with functionality
        if(dataKey&&(dataKey === BusienssControlNames.booknow||dataKey === BusienssControlNames.classes||dataKey===BusienssControlNames.productDetails)){
            document.body.classList.add("hide-cta");

        }

        if(!layout){
            layout = "";
        }

        if (dataKey) {
            ReactDOM.render(<GenericBusinessControl dataKey={dataKey} filters={filters} userContext={context} bLocationId={bid} layout={layout} rootId={element.id.substring(0,6)} allowMultiLoc={allowMulti} isShowLogo={isShowLogo} formbg={formbg} formfc={formfc}  displayform={displayform} />, element);
        }
    })
    }
    catch(e){
        console.warn(e);
    }

    //bind all functional components (image sliders etc)
    let compBindElements = document.querySelectorAll(`[${componetAttKey}]`);

    compBindElements.forEach((element) => {

        let atts = element.getAttribute(componetAttKey)??"";

       
            try {
                let str = decodeURIComponent(atts);
             
                let attData = (str)?JSON.parse(str):{};
                let key = element.getAttribute("componenttype") ?? "";
           
                if ((attData&&str)||(key==wBComponentTypeNames.subscriptionThankYou)) {


                    let node = new LayoutNode();
                    node.id = element.id;//flag to not include atts this way
                    node.componentAttributes = attData;
              
                    element.setAttribute(componetAttKey, ""); //remove all node data from the dom


                    ReactDOM.render(<GenericDynamicComponent dataKey={key} node={node} context={context}  />, element);


                }
            }
            catch (e) {
                console.warn(e);
               
            }


    })


    const embeds = document.querySelectorAll(".v-site.render .v-html-embed script, #head-code script, #footer-code script");



    for(let i = 0;i<embeds.length;i++){

 
        let scrpt = embeds[i];
        
        let src = scrpt.getAttribute("src");
        let parent = scrpt.parentElement;
        
    

   
            if(parent){
            
                let newScript = document.createElement("script");
                newScript.async = true;
                if(src)
                 newScript.src = src+"?cachebuster="+Date.now();
                newScript.innerHTML = scrpt.innerHTML;
            
               parent.replaceChild(newScript,scrpt);
                
            }
    
    }


    BindAllToggles();
    BindServiceLinks(context);
    BindClassLinks(context);
    BindMembershipLinks(context);
    BindPackageLinks(context);
    
    const buttonLinks = document.querySelectorAll(`.scroll-link`);

    for(let i = 0;i<buttonLinks.length;i++){
   
        if(!buttonLinks[i].classList.contains("hierarchy"))
            continue;
        let href = buttonLinks[i].getAttribute("href");
        if(href&&href.startsWith("#")){
            let url = window.location.href;
            let hash = url.indexOf("#");
            if(hash>0){
                url = url.substring(0,hash);
            }
            href = url+ href;
            buttonLinks[i].setAttribute("href",href);
        }

    }

    //annoucement banner
    const clsAnnouncement = document.getElementById("close-announcement-btn");
    if(clsAnnouncement){
        let announcement = clsAnnouncement.parentElement;

        let expiresAt = announcement?.getAttribute("data-expires-at");
        let expired = false;
        if(expiresAt){

            let date = new Date(expiresAt);
            
            if(date &&!isNaN(date.getTime())){
                let now = new Date();
                expired = date.getTime()<now.getTime();
            }

        }


        let storage = window.sessionStorage.getItem("announcement-closed");
        if( (!(window as any).isEditor&&storage&&storage=="true")||expired){
          
            
            if(announcement&&announcement.parentElement){
                announcement.parentElement.removeChild(announcement);
            }
        }


        clsAnnouncement.onclick = (e)=>{
      
            if(clsAnnouncement){
                let announcement = clsAnnouncement.parentElement;
       
                if(announcement&&announcement.parentElement){
                    e.stopPropagation();
                    e.preventDefault();
                    window.sessionStorage.setItem("announcement-closed","true");
                    announcement.parentElement.removeChild(announcement);
                }
            }
        };

    }

    //cookie banner
    const clsCookie = document.getElementById("dismiss-cookie-banner");





    if(clsCookie){

        const declineCookie = document.getElementById("decline-cookie-banner");

        const onIsAccepted = ()=>{

            let dom = document.getElementById('gtag-init');
            if(dom)
                GtagAccept();

    
        }
        let accepted = getCookie(GetTrackingCookieName()) == hasAcceptedValue

        let acceptBtn = document.getElementById("accept-cookie-banner");
   
        const closeBanner = ()=>{
            let parent = clsCookie.parentElement;
            if(parent&&parent.parentElement){
                parent.parentElement.remove();
            }
            
        };

        if(declineCookie){
            declineCookie.onclick = (e)=>{
                closeBanner();
            }
        }

        if(accepted){
            onIsAccepted();
            closeBanner();
         
        }

        else if(acceptBtn){
            acceptBtn.onclick = (e)=>{
              
                setCookie(GetTrackingCookieName(),hasAcceptedValue,365);

                onIsAccepted();

                closeBanner();
            }
        }

        clsCookie.onclick = (e)=>{
            closeBanner();
        };

    }
    else{
        GtagAccept();
    }


    //override static links with preview links
    if(window.location.href.endsWith("/preview")){
        let links = document.querySelectorAll("a");
       
        for(let i = 0;i<links.length;i++){
            if(!links[i].classList.contains("hierarchy"))
                continue;
            let href = links[i].getAttribute("href");
            if(href&&!href.startsWith("http")&&!href.endsWith("/preview")){
                href = href + "/preview";
                links[i].setAttribute("href",href);
            }
        }

    }

    const jsAsCSS = (name: string, value: string) => {
        document.documentElement.style.setProperty(name, value);
    }
    
    const setCSSVariable = () => {
        try{
        var wbcprimaryBtn = document.getElementById('btnprimarybutton')!;
        var wbcprimaryBtnBg = getComputedStyle(wbcprimaryBtn, '').backgroundColor;
        var loaderAlpha = `rgba(${wbcprimaryBtnBg.slice(4, -1)},0.7)`;
        jsAsCSS("--wbc-primary-button-bg", wbcprimaryBtnBg);
        jsAsCSS("--wbc-loader-alpha", loaderAlpha);
        }
        catch(error){
            console.warn(error);
        }
        //console.log(loaderAlpha)
    };
    setCSSVariable()
        
    onFinish&&onFinish();

}
